<template>
  <PressHubModule
    :module-data="document"
    :articles="articles"
    data-luko-tracking="Page-Press"
  />
</template>

<script>
import PressHubModule from '~/modules/PressHub'
import { formatMetaDatas } from '~/utils/metaData'
import { fetchAllDocuments } from '~/utils/prismic/fetch'

export default {
  name: 'PressPage',

  head() {
    const { title, subtitle, backgroundImage } = this.document.body.find(
      (e) => e.slice_type === 'hero'
    ).primary

    const defaultMeta = {
      twitter_title: title[0].text,
      twitter_description: subtitle[0].text,
      twitter_image: backgroundImage.url,
    }

    return formatMetaDatas(this.metaDatas, this.$route.path, defaultMeta)
  },

  components: {
    PressHubModule,
  },

  async asyncData({ app, $prismic, store, error }) {
    try {
      const { data: document, alternate_languages } =
        await $prismic.api.getSingle('press_hub', {
          lang: app.i18n.localeProperties.prismicIso,
        })

      store.dispatch('setAlternateLanguages', alternate_languages)

      // Extract page settings from PageSettings slice.
      store.commit(
        'page/UPDATE',
        document.body.find((s) => s.slice_type === 'page_settings')
      )
      document.body = document.body.filter(
        (s) => s.slice_type !== 'page_settings'
      )

      const articles = await fetchAllDocuments($prismic, {
        type: 'press_article',
        lang: app.i18n.localeProperties.prismicIso,
        orderings: '[my.press_article.date desc]',
      })

      const release = await fetchAllDocuments($prismic, {
        type: 'press_release',
        lang: app.i18n.localeProperties.prismicIso,
        orderings: '[my.press_release.date desc]',
      })

      document.body = document.body
        .map((slice, id, arr) => {
          if (slice.slice_type !== 'press_content') return slice

          // sort articles
          slice.items = slice.items.map((item) => {
            if (item.is_release)
              return {
                ...item,
                items: release,
              }
            return {
              ...item,
              items: articles,
            }
          })

          // add card_list to the sidebar data
          slice.primary = {
            ...slice.primary,
            cardList: arr.filter((e) => e.slice_type === 'card_list')[0]?.items,
            summary: arr.filter((e) => e.slice_type === 'summary_sidebar')[0]
              ?.items,
          }
          return slice
        })
        .filter(
          (slice) =>
            slice.slice_type !== 'card_list' &&
            slice.slice_type !== 'summary_sidebar'
        )

      return {
        document,
        articles,
        metaDatas: document.body1 || [],
      }
    } catch (e) {
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
